import { render, staticRenderFns } from "./RMA.vue?vue&type=template&id=94a017ec"
import script from "./RMA.vue?vue&type=script&lang=js"
export * from "./RMA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports